var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MealContainer',{staticClass:"h-bg-w",attrs:{"viewer":"page","recipeId":_vm.recipeId},on:{"scrollTop":_vm.scrollTop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }